import React from 'react'
import SEO from '../../../utils/CommonFunctionality/SEO'
import SEOTAG from '../../../utils/CommonFunctionality/SEO/AllpagesSEO'
import Layout from '../Layout'

export default function faq(props) {
    const isPrimeBids = global.storeConfigration?.bodyClass?.value == 'primeBids'

    return (
        <>
            {isPrimeBids ? (
                <SEOTAG page="FAQs" />
            ) : (
                <SEO title={`${global?.storeDetails?.name} | Frequently asked questions`} />
            )}
            <Layout props={props}>
                <div className="px-md-5 px-3 py-4 staticPgWrapper">
                    {/* <h2>FAQs</h2> */}
                    <span
                        dangerouslySetInnerHTML={{
                            __html: global.storeDetails.terms,
                        }}
                    ></span>
                </div>
            </Layout>{' '}
        </>
    )
}
